/**
 * Admin Access Control Utilities
 *
 * Controls access to admin-only features based on email domain.
 * Only users from approved domains can access admin functionality.
 */

// Approved admin email domains (hardcoded for security)
const ADMIN_DOMAINS = ['advancer.co.nz', 'advancerlimited.com', 'davidsonchang.com'];

/**
 * Extract domain from email address
 */
export const getEmailDomain = (email: string): string => {
  const parts = email.split('@');
  return parts.length > 1 ? parts[1].toLowerCase() : '';
};

/**
 * Check if an email belongs to an admin domain
 */
export const isAdminDomain = (email: string | null | undefined): boolean => {
  if (!email) return false;
  const domain = getEmailDomain(email);
  return ADMIN_DOMAINS.includes(domain);
};

/**
 * Get list of admin domains (for display purposes)
 */
export const getAdminDomains = (): readonly string[] => ADMIN_DOMAINS;
